// src/components/protectedRoute.jsx
import React, { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import Cookies from "universal-cookie";
import { AuthContext } from "../base/context/authcontext";

// Helpers de evaluación de permisos
const getFlag = (perms, moduleKey, action = "can_access_module") =>
  Boolean(perms?.[moduleKey]?.[action]);

const evalSingle = (perms, rule) => {
  if (!rule) return true; // si no hay regla, pasa
  const { module: moduleKey, action = "can_access_module" } = rule;
  if (!moduleKey) return true;
  return getFlag(perms, moduleKey, action);
};

const evalRules = (perms, require) => {
  if (!require) return true;

  // Soporta: { module, action }
  if (require.module) return evalSingle(perms, require);

  // Soporta: { anyOf: [ {module, action}, ... ] }
  if (Array.isArray(require.anyOf)) {
    return require.anyOf.some((r) => evalSingle(perms, r));
  }

  // Soporta: { allOf: [ {module, action}, ... ] }
  if (Array.isArray(require.allOf)) {
    return require.allOf.every((r) => evalSingle(perms, r));
  }

  return true;
};

const ProtectedRoute = ({ children, require }) => {
  const location = useLocation();
  const cookies = new Cookies();
  const { authData } = useContext(AuthContext);

  const hasToken = Boolean(cookies.get("session_token"));
  const isAuth = Boolean(authData?.isAuthenticated);
  if (!hasToken || !isAuth) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const permissions = authData?.user_data?.role?.permissions || {};
  const allowed = evalRules(permissions, require);

  if (!allowed) {
    return <Navigate to="/forbidden" replace />;
  }

  return children;
};

export default ProtectedRoute;
